import { render, staticRenderFns } from "./MatchCentre.vue?vue&type=template&id=372d9b13&scoped=true&"
import script from "./MatchCentre.vue?vue&type=script&lang=js&"
export * from "./MatchCentre.vue?vue&type=script&lang=js&"
import style0 from "./MatchCentre.vue?vue&type=style&index=0&id=372d9b13&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372d9b13",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PredictorShare: require('/src/components/MatchComponents/LineUpSelector/PredictorShare.vue').default,Loader: require('/src/components/Loaders/Loader.vue').default,ArticleHero: require('/src/components/Content/Article/ArticleHero.vue').default,Content: require('/src/components/Content/Content.vue').default,MatchHero: require('/src/components/MatchCentre/Hero/MatchHero.vue').default,MatchCentreTabs: require('/src/components/MatchCentre/MatchCentreTabs.vue').default,MatchCentreTabMedia: require('/src/components/MatchCentre/Tabs/MatchCentreTabMedia.vue').default,MatchCentreTabLive: require('/src/components/MatchCentre/Tabs/MatchCentreTabLive.vue').default,MatchCentreTabEditorial: require('/src/components/MatchCentre/Tabs/MatchCentreTabEditorial.vue').default,MatchCentreTabLineups: require('/src/components/MatchCentre/Tabs/MatchCentreTabLineups.vue').default,MatchCentreTabStats: require('/src/components/MatchCentre/Tabs/MatchCentreTabStats.vue').default})
